import { Route, Routes } from "react-router-dom";

import AllTemplates from "./AllTemplates";

export default function Templates() {
  return (
    <Routes>
      <Route path="/*" element={<AllTemplates />} />
    </Routes>
  );
}
